export default __webpack_public_path__ + "static/media/mineraluld.bd13cf38.svg";